export default __webpack_public_path__ + "static/media/17thEPEAd.91a59e02.9f4b7f17.jpg";